import { Component, OnInit } from '@angular/core';
import {paramsHelper} from "../../helpers/params-helper";
import {IDocument} from "../../interfaces/document.definition";
import {BusService} from "../../services/bus.service";
import {DOCUMENT_TYPES, VALUE_TYPE} from "../../enums/enums";
import {E_ENDPOINTS} from "../../helpers/params/loader-params";

@Component({
  selector: 'app-geos-list-page',
  templateUrl: './geos-list-page.component.html',
  styles: []
})
export class GeosListPageComponent implements OnInit {

  VAL_TYPES = VALUE_TYPE;

  pageParams = paramsHelper.page()
    .setDisabledOptionVisible(true)
    .setTitle("Список геолокаций");

  document:IDocument;

  collectionParams = paramsHelper.collection()
    .setDuplicateEnabled(false)
    .setDefaultListLabels()
    .setItemLabelQuery('name')
    .setObjectType(DOCUMENT_TYPES.GEO);


  constructor(private busService:BusService) { }

  ngOnInit() {
    this.busService.onDocumentUpdated
      .subscribe(e => this.updateDocument(e.document as IDocument));
  }

  private updateDocument(document:IDocument){
    this.document = document;
  }


}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/pages/geos-list-page/geos-list-page.component.ts